import { useEffect } from 'react'

/**
 * Determines if click is within current ref
 * @param ref ref to current node (pointer to specific node)
 * @param handler on click handler
 */
export const useOnClickOutside = (ref: React.RefObject<HTMLDivElement | null>, handler: () => void) => {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return
      }
      handler()
    }

    document.addEventListener('mousedown', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
    }
  }, [ref, handler])
}

/**
 * Determines if click is within current list of refs
 * @param ref ref to current node (pointer to specific node)
 * @param handler on click handler
 */
export const useOnClickOutsideMultiple = (refs: React.RefObject<HTMLDivElement | null>[], handler: () => void) => {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      const isInside = refs.some(ref => ref.current && ref.current.contains(event.target as Node))

      if (isInside) return
      handler()
    }

    document.addEventListener('mousedown', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
    }
  }, [refs, handler])
}
